import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ConfirmationService } from 'primeng/api';
import { NavMenuService } from '../../../core/components/navmenu/navmenu.service';
import { ComponentBase } from '../../../core/_infrastructure/classes/componentBase';
import { ExceptionManager } from '../../../core/_infrastructure/classes/handlers/exceptionManager';
import { AuthService } from '../../../core/_infrastructure/classes/services/auth.service';
import { NotificationService } from '../../../core/_infrastructure/classes/services/notification.service';
import { EnumCodigosTwTcAcciones } from '../../../_importacion/solicitudes/types/enum';
import { SolicitudAtestFitoService } from '../datosbasicos/datosbasicosAtestFito.service';
import { TDatosResponsableCaAcViewModel, TSolicitudResultadoAtestFitoViewModel } from '../resultado/resultado.types';
import { ResultadoService } from '../resultado/resultado.service';
import { ResumenAtestFitoService } from '../resumen/resumen-list.service';
import { ResumenSolicitudAtestFitoViewModel } from '../resumen/resumen-list.types';
import { EnumIdsTcEstadoSolicitudEx } from '../../solicitudes/types/enum';

@Component({
    selector: 'app-anulacionAtestFito-edit',
    templateUrl: './anulacionAtestFito-edit.component.html',
})
export class AnulacionAtestFitoEditComponent extends ComponentBase implements OnInit {
    editMode = false;
    nombreUsuario = '';
    solicitudAnulacionAtestFito: TDatosResponsableCaAcViewModel; //RDLF: uso este model ya que se van a guardar los datos en esta tabla
    nuevaSolicitudAnulacionAtestFito: TSolicitudResultadoAtestFitoViewModel; //RDLF: uso este model ya que se van a guardar los datos en esta tabla
    resumenAtestFitoCollection: ResumenSolicitudAtestFitoViewModel[];
    idSolicitudAtestFito: number;
    codigoTipoSolicitud: string;
    tituloTipoSolicitudAtestFito: string;
    IdEstadoSolicitudAtestFito: number;
    tituloEstadoSolicitudAtestFito: string;
    refAtestFito: string;
    IdTipoSolicitudAtestFito: number;

    nombreTecResponsable: string;

    habilitarGuardar = true;
    visibilitySpinner = false;

    constructor(
        public datepipe: DatePipe,
        private activatedRoute: ActivatedRoute,
        private router: Router,
        private fb: UntypedFormBuilder,
        private solicitudAtestService: SolicitudAtestFitoService,
        private navMenuService: NavMenuService,
        private anulacionAtestFitoService: ResultadoService, //RDLF: uso el mismo service que 'Resultado', por usar el mismo model
        private resumenAtestFitoService: ResumenAtestFitoService,
        private confirmationService: ConfirmationService,
        protected authService: AuthService,
        protected notificacionService: NotificationService,
        protected exceptionHandler: ExceptionManager,
    ) {
        super(authService, notificacionService, exceptionHandler);

        this.solicitudAnulacionAtestFito = new TDatosResponsableCaAcViewModel();
    }

    ngOnInit() {
        let id = +this.activatedRoute.snapshot.params['id'];
        this.idSolicitudAtestFito = id;

        //Se obtienen las solicitudes vinculadas, y su estado
        this.resumenAtestFitoService.getSolicitudResumenAtestFito(this.idSolicitudAtestFito).subscribe(result => {
            this.resumenAtestFitoCollection = result.TSolicitudAtestFitoSolicitudExCollection;
        });

        this.nombreTecResponsable = this.loggedInUser!.Nombre + ' ' + this.loggedInUser!.Apellidos;

        this.guardRefreshPage(this.idSolicitudAtestFito);

        this.createForm();

        if (this.idSolicitudAtestFito) {
            this.loading = true;

            this.anulacionAtestFitoService.getResultadoSolicitudAtestFito(this.idSolicitudAtestFito).subscribe(result => {
                if (result) {
                    this.editMode = true;

                    this.solicitudAnulacionAtestFito = result;

                    this.IdTipoSolicitudAtestFito = this.solicitudAnulacionAtestFito.IdTipoSolicitud;
                    this.IdEstadoSolicitudAtestFito = this.solicitudAnulacionAtestFito.IdEstado;
                    this.tituloTipoSolicitudAtestFito = this.solicitudAnulacionAtestFito.IdTipoSolicitudDescripcion;
                    this.tituloEstadoSolicitudAtestFito = this.solicitudAnulacionAtestFito.IdEstadoDescripcion;
                    this.codigoTipoSolicitud = this.solicitudAnulacionAtestFito.CodigoTipoSolicitud;
                    this.refAtestFito = this.solicitudAnulacionAtestFito.RefAtestFito;

                    this.habilitarGuardar = this.loggedInUser!.getAction(
                        EnumCodigosTwTcAcciones.MENU_ANULACION_ATESTACION,
                        this.solicitudAnulacionAtestFito.IdEstado,
                        this.solicitudAnulacionAtestFito.IdTipoSolicitud,
                    ).Editable;

                    //es ANULACION si el idResultado esta a NULL
                    if (this.solicitudAnulacionAtestFito.IdResultadoSolicitudAtestFito == null) {
                        this.updateForm();
                    }

                    if (!this.habilitarGuardar) {
                        this.form.controls['Observaciones'].disable();
                    }
                } else {
                    this.anulacionAtestFitoService.getSolicitudAtestFitoAgenteControl(id).subscribe(result => {
                        this.editMode = false;

                        this.nuevaSolicitudAnulacionAtestFito = result;

                        this.IdTipoSolicitudAtestFito = this.nuevaSolicitudAnulacionAtestFito.IdTipoSolicitud;
                        this.IdEstadoSolicitudAtestFito = this.nuevaSolicitudAnulacionAtestFito.IdEstado;
                        this.tituloTipoSolicitudAtestFito = this.nuevaSolicitudAnulacionAtestFito.IdTipoSolicitudDescripcion;
                        this.tituloEstadoSolicitudAtestFito = this.nuevaSolicitudAnulacionAtestFito.IdEstadoDescripcion;
                        this.codigoTipoSolicitud = this.nuevaSolicitudAnulacionAtestFito.CodigoTipoSolicitud;

                        this.refAtestFito = this.nuevaSolicitudAnulacionAtestFito.RefAtestFito;

                        this.habilitarGuardar = this.loggedInUser!.getAction(
                            EnumCodigosTwTcAcciones.MENU_ANULACION_ATESTACION,
                            this.nuevaSolicitudAnulacionAtestFito.IdEstado,
                            this.nuevaSolicitudAnulacionAtestFito.IdTipoSolicitud,
                        ).Editable;

                        //this.form.setValue({

                        //    NombreAgenteControl: this.nuevaSolicitudAnulacionAtestFito.NombreAgenteControl,

                        //    NombreTecResponsable: '',
                        //    Observaciones: ''
                        //});

                        if (!this.habilitarGuardar) {
                            this.form.controls['Observaciones'].disable();
                        }
                    });
                }
            });

            this.loading = false;
        }
    }

    guardRefreshPage(id: number) {
        if ((id && !this.navMenuService.currentSolicitudAtestacion.Id) || this.navMenuService.currentSolicitudAtestacion.Id !== id) {
            this.solicitudAtestService.getSolicitudAtestFito(id).subscribe(result => {
                this.navMenuService.currentSolicitudAtestacion = result;
            });
        }
    }

    createForm() {
        this.form = this.fb.group({
            NombreTecResponsable: '',
            NombreAgenteControl: '',
            //IdUsuarioAc: null,
            Observaciones: ['', Validators.required],
            FechaAnulacion: [{ value: '', disabled: true }],
        });
    }

    updateForm() {
        this.form.setValue({
            NombreTecResponsable: this.solicitudAnulacionAtestFito.NombreTecResponsable,
            NombreAgenteControl: this.solicitudAnulacionAtestFito.NombreAgenteControl,
            Observaciones: this.solicitudAnulacionAtestFito.Observaciones,
            //IdUsuarioAc: this.solicitudAnulacionAtestFito.IdUsuarioAc,
            FechaAnulacion: new Date(this.solicitudAnulacionAtestFito.FechaFinalizacion!),
        });
    }

    onBack() {
        this.router.navigate(['/exportacion/atestaciones']);
    }

    enviarAnulacion() {
        let msgConfirmAnulacion = '';
        //Se comprueba si tiene solicitudes vinculadas NO anuladas
        if (
            this.resumenAtestFitoCollection.length > 0 &&
            this.resumenAtestFitoCollection.find(x => x.IdEstadoSolicitudEx != EnumIdsTcEstadoSolicitudEx.ID_ANULADA) != null
        ) {
            msgConfirmAnulacion =
                'Existen CF no anulados con cargo a esta atestación fitosanitaria. Puede ver los detalles en el apartado Resumen.\n¿Desea continuar con la anulación?. Tenga en cuenta que no podrá deshacer la operación.';
        } else {
            msgConfirmAnulacion = '¿Está seguro de anular la solicitud actual?.\nTenga en cuenta que no podrá deshacer la operación.';
        }

        this.confirmationService.confirm({
            message: msgConfirmAnulacion,
            accept: () => {
                this.onSubmit();
            },
        });
    }

    onSubmit() {
        this.submitted = true;

        if (!this.form.valid) {
            return;
        }

        this.visibilitySpinner = true;

        let anulacionAtestFito = new TDatosResponsableCaAcViewModel(); //RDLF: uso este model ya que se van a guardar los datos en esta tabla

        anulacionAtestFito.IdSolicitudAtestFito = this.idSolicitudAtestFito;

        anulacionAtestFito.Observaciones = this.form.value.Observaciones;

        if (this.codigoTipoSolicitud == 'CA') {
            anulacionAtestFito.NombreTecResponsable = this.nombreTecResponsable;
            //si es tipo CA le paso el usuario logado en el campo IdUsuarioAc para guardar el IdUsuarioCa de la solicitudAtestFito
            anulacionAtestFito.IdUsuarioAc = this.loggedInUser!.Id;
        } else if (this.codigoTipoSolicitud == 'AC') {
            anulacionAtestFito.IdUsuarioAc = this.loggedInUser!.Id;
        }

        if (this.editMode) {
            this.anulacionAtestFitoService.editResultadoAtestFito(anulacionAtestFito).subscribe({
                next: () => {
                    this.addSuccessMessage('Solicitud anulada correctamente');
                    //this.onBack();
                    this.visibilitySpinner = false;
                    this.ngOnInit();
                },
                error: error => {
                    this.catchServerError(error);
                    this.visibilitySpinner = false;
                },
            });
        } else {
            this.anulacionAtestFitoService.createResultadoAtestFito(anulacionAtestFito).subscribe({
                next: () => {
                    this.addSuccessMessage('Solicitud anulada correctamente');
                    //this.onBack();
                    this.visibilitySpinner = false;
                    this.ngOnInit();
                },
                error: error => {
                    this.catchServerError(error);
                    this.visibilitySpinner = false;
                },
            });
        }
    }
}
